import { motion } from "framer-motion";
import image from "../../../../assets/windTree/images/aboutUs/aboutBanner.webp";
import ceo from "../../../../assets/windTree/images/aboutUs/nitin-singla.jpg";
import team from "../../../../assets/windTree/images/aboutUs/yogesh.jpg";
import Heading from "../utils/Heading";
import image1 from "../../../../assets/windTree/images/certificates/5998-QCCI_GMP_SOFT_COPY_OF_STRIDUM_VENTURE_PVT._LTD._page-0001.jpg";
import image2 from "../../../../assets/windTree/images/certificates/5999-QCCI_NON_GMO_SOFT_COPY_OF_STRIDUM_VENTURE_PVT._LTD._page-0001.jpg";
import image3 from "../../../../assets/windTree/images/certificates/Bronze_page-0001.jpg";
import image4 from "../../../../assets/windTree/images/certificates/ISO_certificate_stridum_page-0001.jpg";
// import image5 from "../../../../assets/windTree/images/certificates/Certificate.jpg";
const services = [
  {
    image: "https://i.postimg.cc/RF5gDzvD/img9.jpg",
  },
  {
    image: "https://i.postimg.cc/ZnYFGbXY/img10.jpg",
  },
];
const images = [image1, image2, image3, image4];
const teamMembers = [
  {
    id: 1,
    name: " Nitin Singla",
    role: "President & CEO",
    image: ceo,
    description: "Nitin Singla is the driving force behind Umbrona Designs’ vision and growth, leveraging over two decades of experience across manufacturing, business development, and window covering solutions to build a trusted brand known for quality, innovation, dependable products, thoughtful execution, and strong value."
  },
  {
    id: 2,
    name: "Yogesh Kumar",
    role: " General Manager - Production",
    image: team,
    description: "Yogesh Kumar leads production with strong expertise in window blinds, automation technologies, and process improvement, bringing a practical, systems-driven approach as an electronics and communication engineer that strengthens product quality and manufacturing performance through innovation, production efficiency, and cross-functional execution across procurement, inventory, and supply chain operations."
  }
];

const AboutUsPage = () => {
  return (
<div className="bg-white text-gray-800 space-y-6">
      {/* 🖼️ Hero/Banner Section */}
<div className="relative w-full min-h-[50vh] md:min-h-[65vh] lg:min-h-[75vh]">        {/* Background Banner */}
        <img
          src={image}
          alt="About Us Banner"
className="w-full h-[50vh] md:h-[65vh] lg:h-[75vh] object-cover"        />

        {/* Overlay Text */}
        <div className="absolute inset-0 flex flex-col justify-center items-center bg-black/30 text-white text-center">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold tracking-wide">About Us</h1>
          <p className="mt-2 text-base md:text-lg max-w-2xl">
            Redefining Window Style and Comfort
          </p>
        </div>
      </div>

      {/* 🏢 About Stridum Ventures Section */}
      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-md  border mt-5 border-gray-100 max-w-7xl mx-auto m-10 p-8 md:p-12 container"      >
        <div className="text-center mb-8">
          
<Heading
  text={"About Stridum Ventures"}
  className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-center"
/>

<div className="w-10 sm:w-12 md:w-16 lg:w-20 xl:w-24 h-1 bg-gradient-to-r from-green-600 to-green-700 mx-auto mt-2 sm:mt-3 md:mt-4 lg:mt-5 rounded-full"></div>
        </div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
          <motion.p
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.6, duration: 0.7 }}
            className="flex items-start"
          >

            <p className="ml-6">Umbrona Designs is the flagship brand of Stridum Venture Pvt Ltd, built on over two decades of manufacturing expertise. We specialize in customized  window covering solutions designed for performance, and durability.
            </p>

          </motion.p>

          <motion.p
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.7, duration: 0.7 }}
            className="flex items-start"
          >

            <p className="ml-6"> Our product range includes high-performance window blinds, insulated glass blind systems, wallpapers, and customized flooring and ceiling systems for homes, offices, hospitals, and large commercial spaces.</p>
          </motion.p>

          <motion.p
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.8, duration: 0.7 }}
            className="flex items-start"
          >

            <p className="ml-6">With advanced in-house manufacturing and carefully selected materials, every product is crafted for durability, precision, and lasting performance. At Umbrona Designs, our focus is simple, which is to deliver reliable, professionally engineered solutions to residential, commercial, and government clients across India and beyond.
            </p>
          </motion.p>

          {/* <motion.p
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.9, duration: 0.7 }}
            className="flex items-start"
          >
            <span className="text-2xl text-red-500 mr-3">•</span>
            <span>The sole purpose of rendering quality and professional Window treatment solution services to private home, state owned companies, private, commercial offices and the public sector units in India and beyond our borders.</span>
          </motion.p> */}

          {/* <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.1, duration: 0.6 }}
            className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6 border-l-4 border-blue-500 mt-8"
          >
            <p className="text-xl font-semibold text-gray-800 text-center">
              We are one of the distinguished manufacturer of world class blinds under brand name
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent font-bold text-2xl ml-2">"WINTREE"</span>
            </p>
          </motion.div> */}
        {/* </div> */}
      {/* </motion.div> */} 
      <motion.div
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.3, duration: 0.8 }}
  className="md:bg-gradient-to-br from-white to-gray-50 rounded-2xl md:shadow-md md:border md:border-gray-100 max-w-7xl mx-auto mt-2 md:!mt-5 lg:!mt-20 px-4 sm:px-6 md:px-8 lg:px-10 lg:py-6 md:py-4"
>

  <div className="text-center mb-3 md:mb-6">

    <Heading
      text={"About Umbrona Designs"}
      className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-center"
    />

    <div className="w-10 sm:w-12 md:w-16 lg:w-20 xl:w-24 h-1 bg-gradient-to-r from-green-600 to-green-700 mx-auto rounded-full"></div>

  </div>

<div className="space-y-1 sm:space-y-2  md:space-y-4 lg:space-y-6 text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
    <motion.p
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.6, duration: 0.7 }}
      className="flex items-start"
    >
      <p className="ml-2 sm:-mt-2 md:-mt-2 sm:ml-4 md:ml-6">
        Umbrona Designs is the flagship brand of Stridum Venture Pvt Ltd, built on over two decades of manufacturing expertise. We specialize in customized window covering solutions designed for performance and durability.
      </p>
    </motion.p>

    <motion.p
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.7, duration: 0.7 }}
      className="flex items-start"
    >
      <p className="ml-2 sm:ml-4 md:ml-6 sm:-mt-2 md:-mt-2">
        Our product range includes high-performance window blinds, insulated glass blind systems, wallpapers, and customized flooring and ceiling systems for homes, offices, hospitals, and large commercial spaces.
      </p>
    </motion.p>

    <motion.p
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.8, duration: 0.7 }}
      className="flex items-start"
    >
      <p className="ml-2 sm:ml-4 md:ml-6 sm:-mt-2 md:-mt-2">
        With advanced in-house manufacturing and carefully selected materials, every product is crafted for durability, precision, and lasting performance. At Umbrona Designs, our focus is simple: delivering reliable, professionally engineered solutions to residential, commercial, and government clients across India and beyond.
      </p>
    </motion.p>

  </div>

</motion.div>


      {/* --- */}

      {/* 🖼️ Collections & Why Choose Us Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative py-7 px-6 overflow-hidden"
      >
        {/* Soft Background Light Spots */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-green-200/30 blur-3xl rounded-full"></div>
        <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-200/30 blur-3xl rounded-full"></div>

        <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row gap-8 md:gap-12 items-start">

          {/* LEFT — ENHANCED IMAGE SECTION (Our Collections) */}
          <div className="flex-1 w-full space-y-8">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-start space-y-4"
            >
              {/* Enhanced Badge */}
              {/* <div className="inline-flex items-center gap-2 px-5 py-2 bg-white/80 backdrop-blur-sm border border-green-200 rounded-2xl shadow-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-green-700 font-semibold text-sm">PREMIUM SELECTION</span>
              </div> */}
              <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 bg-white/80 backdrop-blur-sm border border-green-200 rounded-2xl shadow-sm">
  <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-500 rounded-full animate-pulse"></div>
  <span className="text-[#0d5f07] font-semibold text-xs sm:text-sm md:text-base">
    PREMIUM SELECTION
  </span>
</div>

{/* <Heading text={"our "} subText={"collections"} className="sm:text-2xl md:text-4xl lg:text-6xl " />               */}
            </motion.div>

            {/* Enhanced Image Grid */}
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {services.slice(0, 2).map((member, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.95, y: 20 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  transition={{
                    delay: 0.4 + index * 0.15,
                    type: "spring",
                    stiffness: 100
                  }}
                  className="group cursor-pointer"
                > */}
                <div className="grid md:grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8 px-2 sm:px-4">
  {services.slice(0, 2).map((member, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, scale: 0.95, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{
        delay: 0.4 + index * 0.15,
        type: "spring",
        stiffness: 100
      }}
      className="group cursor-pointer w-full"
    >
                  {/* <div className=" relative h-56 sm:h-64 md:h-72 rounded-2xl overflow-hidden shadow-xl bg-white hover:shadow-2xl transition-all duration-500 border border-gray-100">

                    <img
                      src={member.image}
                      className="w-full h-full object-cover duration-700 transform group-hover:scale-110"
                      alt={`Collection Item ${index + 1}`}
                    /> */}
                    <div className="relative w-full h-44 sm:h-52 md:h-48 rounded-2xl overflow-hidden shadow-xl bg-white hover:shadow-2xl transition-all duration-500 border border-gray-100">

<img
  src={member.image}
  alt={`Collection Item ${index + 1}`}
  className="w-full h-full object-cover duration-700 transform group-hover:scale-110"
/>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500"></div>

                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent transform -skew-x-12 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>

                   <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 md:p-6 text-white transform translate-y-0 group-hover:translate-y-[-5px] transition-transform duration-300">

  <h3 className="text-base sm:text-lg md:text-xl font-bold mb-1 sm:mb-2">
    {member.name || ""}
  </h3>

  <div className="flex items-center justify-between">
    
    <p className="text-green-300 text-xs sm:text-sm font-medium">
      {member.role || ""}
    </p>

    <div className="flex items-center space-x-1">
      <div className="w-1 h-1 bg-green-400 rounded-full animate-pulse"></div>
      <div className="w-1 h-1 bg-green-400 rounded-full animate-pulse" style={{ animationDelay: "0.2s" }}></div>
      <div className="w-1 h-1 bg-green-400 rounded-full animate-pulse" style={{ animationDelay: "0.4s" }}></div>
    </div>

  </div>
</div>

                    {/* Enhanced Action Button */}
                    <div className="absolute top-5 right-5 w-10 h-10 bg-white/95 rounded-full flex items-center justify-center 
                    opacity-0 group-hover:opacity-100 transform scale-0 group-hover:scale-100 rotate-0 group-hover:rotate-45 
                    transition-all duration-500 shadow-lg border border-green-200">
                      <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                    </div>

                    {/* Corner Accents */}
                    <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-green-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-green-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-green-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-green-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* RIGHT — COMPACT & CLEAN CONTENT (Why Choose Us) */}
          <div className="flex-1 space-y-8">
            {/* Compact Header */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5 }}
              className="space-y-4"
            >
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-green-100 text-[#0d5f07] rounded-full text-sm font-medium">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                Why Choose Us
              </div>

              {/* <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
                Our Commitment
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-500"> to Quality </span>
              </h3> */}
              <Heading text={"Our Commitment "} subText={"to Quality"} className="text-xl !text-start sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl"


 />              


            </motion.div>

            {/* Compact Features */}
            {/* <div className="space-y-1">
              {[
                "High-capacity in-house manufacturing setup. ",
                " 12,000 sq. ft. dedicated production facility.  ",
                "250+ dealers across India. ",
                "Specialists in insulated glass blinds. ",
                " Self-invented seamless stitching technology. ",
                " ISO 9001:2015 certified quality standards."
                ,].map((text, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.6 + index * 0.08 }}
                    className="flex items-center gap-3 p-1 hover:bg-green-50 rounded-lg -mt-5 transition-colors duration-200"
                  >
                    <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-gray-700 text-sm font-medium">{text}</span>
                  </motion.div>
                ))}
            </div> */}
            <div className="space-y-0 sm:space-y-1 md:space-y-2 " >
  {[
    "High-capacity in-house manufacturing setup.",
    "12,000 sq. ft. dedicated production facility.",
    "250+ dealers across India.",
    "Specialists in insulated glass blinds.",
    "Self-invented seamless stitching technology.",
    "ISO 9001:2015 certified quality standards."
  ].map((text, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.6 + index * 0.08 }}
      className="flex items-start gap-2 sm:gap-3 p-1 sm:p-1 md:p-2 hover:bg-green-50 rounded-lg transition-colors duration-200"
    >
      <div className="w-5 h-5 sm:w-6 sm:h-6 bg-[#0d5f07] rounded-full flex items-center justify-center flex-shrink-0">
        <svg
          className="w-3 h-3 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      <span className="text-gray-700 text-xs sm:text-sm md:text-base font-medium leading-relaxed">
        {text}
      </span>
    </motion.div>
  ))}
</div>

            {/* Simple Stats */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.1 }}
              className="grid grid-cols-3 gap-4 pt-6 border-t border-gray-200"
            >
              <div className="text-center">
                <div className="text-2xl font-bold text-[#0d5f07]">250+</div>
                <div className="text-xs text-gray-600">Dealers</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-[#0d5f07]">12K</div>
                <div className="text-xs text-gray-600">Sq. Ft.</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-[#0d5f07]">ISO</div>
                <div className="text-xs text-gray-600">Certified</div>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      <Heading
  text={"Meet Our Leadership"}
  className="text-center whitespace-nowrap text-xl sm:text-2xl md:text-3xl lg:text-4xl"
/>

<hr className="heading-seperator border-t-4 border-[#66944b] opacity-100 w-12 sm:w-16 md:w-20 lg:w-24 mx-auto  mt-2  md:mt-4" />
      {/* --- */}

      {/* 🧑‍💼 Team Members / Management Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
className="flex flex-col gap-4 sm:gap-6 md:gap-8 bg-white py-4 sm:py-8 md:py-12 items-center mx-2 sm:mx-3 md:mx-6 -mt-6 sm:-mt-10 md:-mt-12"> 
     <div className="flex max-w-7xl px-4 gap-8 md:gap-12 items-stretch justify-center flex-col md:flex-row">
          {teamMembers.map((member) => (
            <div key={member.id} className="flex-1 sm:-mt-25   md:-mt-25 space-y-5 items-center justify-center text-center bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 p-6 border border-gray-100 relative pt-20"> {/* Added pt-20 for top padding */}

              {/* Fixed Rounded Profile Image on Top */}
              <div className="absolute -top-0 left-1/2 transform -translate-x-1/2 z-10">{/* Increased negative top value */}
                <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full border-4 border-white shadow-xl overflow-hidden bg-white mt-2"> {/* Increased size to w-24 h-24 */}
                  <img
                    src={member.profileImage || member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Blob container - Keeping the original SVG structure */}
              <div className="w-full flex justify-center items-center">
                <div className="w-full h-full relative">
                  <svg
                    viewBox="0 0 500 500"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute inset-0 w-full h-full"
                  >
                    <defs>
                      <clipPath id="blobClip" clipPathUnits="objectBoundingBox">
                        <path d="
          M0.61,0.03 
          C0.75,0.09,0.92,0.22,0.97,0.39 
          C1.03,0.57,0.95,0.79,0.8,0.9 
          C0.65,1.00,0.44,1.00,0.27,0.94 
          C0.10,0.87,-0.05,0.74,0.01,0.57 
          C0.07,0.40,0.25,0.27,0.39,0.17 
          C0.52,0.07,0.47,-0.01,0.61,0.03Z
        " />
                      </clipPath>
                    </defs>

                    {/* This image tag is attempting to use a blob shape clip path, but it's currently hidden by the absolute image above. 
                        It is kept here to maintain the structure you provided. */}
                    <image
                      href={member.image}
                      width="100%"
                      height="100%"
                      preserveAspectRatio="xMidYMid slice"
                      clipPath="url(#blobClip)"
                      className="transform transition-all duration-700 group-hover:scale-110 opacity-0" // Added opacity-0 to hide the blob image
                    />
                  </svg>
                </div>
              </div>

              <h2 className="text-xl font-bold text-gray-800 mt-4">{member.name}</h2>
              <div className="w-16 h-1 mt-2 bg-green-500 mx-auto rounded-full"></div>
              <p className="text-[#0d5f07] font-medium text-sm uppercase tracking-wide">{member.role}</p>
              <p className="text-gray-800 leading-relaxed text-justify md:text-center text-sm bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-2xl border border-green-100">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </motion.div>

      {/* 🏆 CERTIFICATION SECTION WITH HEADING */}
      <div className="relative w-full overflow-hidden ">

        {/* 🎯 CERTIFICATION HEADER - TOP SECTION */}
        <div className="text-center mb-12">


          {/* <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Certifications &
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-500"> Accreditations</span>
          </h2> */}
          <Heading
  text={"Certifications & Accreditations"}
  className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-center"
/>

<div className="w-12 sm:w-16 md:w-20 lg:w-24 h-1 bg-gradient-to-r from-green-600 to-green-700 mx-auto rounded-full"></div>
          <div className="flex justify-center items-center gap-4 mb-2">
           
          </div>

         <p className="text-gray-600 max-w-md sm:max-w-xl md:max-w-2xl lg:max-w-3xl mx-auto text-sm sm:text-base md:text-lg sm:mb-8 px-3 sm:px-4 md: -mb-6">
  Recognized by leading global organizations for our commitment to
  <span className="font-semibold text-green-700"> quality, innovation, and excellence</span>
</p>
        </div>





        {/* 🎯 SLIDER - PURE CERTIFICATES */}
        <motion.div
          className="flex gap-6 md:gap-8 w-[90vw] sm:w-[60vw] md:w-[45vw] lg:w-[30vw] mb-10"
          animate={{ x: ["0%", "-100%"] }}
          transition={{
            ease: "linear",
            duration: 50,
            repeat: Infinity,

          }}
        >
          {[...images, ...images].map((img, index) => (
            <div
              key={index}
              className="
          flex-shrink-0
          w-[85vw] sm:w-[45vw] lg:w-[30vw]
          max-w-[650px]
          relative
          group
        "
            >


              {/* 🎯 PURE IMAGE */}
              <img
                src={img}
                alt={`Certificate ${(index % images.length) + 1}`}
                className="
            w-full
            h-auto
            object-contain
            transition-transform
            duration-500
            group-hover:scale-105
          "
              />

              {/* 🎯 BOTTOM LABEL - ON HOVER */}
              <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-white 
        p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300
        text-center text-xs backdrop-blur-sm">
                {(index % images.length) === 0 && "GMP Certified • ISO 9001:2015"}
                {(index % images.length) === 1 && "NON-GMO Certified • QCCI"}
                {(index % images.length) === 2 && "ZED BRONZE • MSME"}
                {(index % images.length) === 3 && "ISO 9001:2015 • Quality Management"}
                {/* {(index % images.length) === 4 && "SOMFY Distribution Partner"} */}
              </div>
            </div>
          ))}
        </motion.div>

        {/* 🎯 VIEW ALL CERTIFICATES BUTTON */}

      </div>



    </div >
  );
};

export default AboutUsPage;